<template>
  <v-container>
    <div class="page">
      <div class="title">Databases to support ExposomeX platform:</div>
      <div>
        <b>DB_Exposure</b>: environmental factors (single or mixture exposure)
      </div>
      <v-divider class="line"></v-divider>
      <div v-for="(item, index) in DBExposure" :key="index">
        <div class="item-context">
          <span class="item-word-1">
            {{item.name}}
          </span>
          <v-btn variant="tonal" color="info" class="mr-2" size="x-small" @click="download_gz(item)">Download</v-btn>
        </div>
        <v-divider class="line"></v-divider>
      </div>
      <div v-for="(item, index) in data" :key="index">
        <div class="item-context">
          <span class="item-word">
            <b>{{item.name}}</b>: {{item.description}}
          </span>
          <v-btn variant="tonal" color="info" class="mr-2" size="x-small" @click="download_gz(item)">Download</v-btn>
        </div>
        <v-divider class="line"></v-divider>
      </div>
     </div>
  </v-container>
</template>
<script>
import { getDownloadUrl } from '@/config'

export default {
  data() {
    return {
      DBExposure: [{
        name: 'DB_Exposure_EXE_CAS',
        router: 'DB_Exposure_Unfold_EXE_CAS',
      },{
        name: 'DB_Exposure_EXE_INCHI',
        router: 'DB_Exposure_Unfold_EXE_INCHI',
      },{
        name: 'DB_Exposure_EXE_SMILES',
        router: 'DB_Exposure_Unfold_EXE_SMILES',
      },{
        name: 'DB_Exposure_EXE_SYNONYM',
        router: 'DB_Exposure_Unfold_EXE_SYNONYM',
      },{
        name: 'DB_Exposure_EXE_IUPAC',
        router: 'DB_Exposure_Unfold_EXE_IUPAC',
      },{
        name: 'DB_Exposure_EXE_CID',
        router: 'DB_Exposure_Unfold_EXE_CID',
      },{
        name: 'DB_Exposure_EXE_SOURCE',
        router: 'DB_Exposure_Unfold_EXE_SOURCE',
      }],
      data: [{
        name: 'DB_Disease',
        router: 'DB_Disease_Fold',
        description: 'diseases'
      },{
        name: 'DB_Enzyme',
        router: 'DB_Enzyme_Fold',
        description: 'enzyme'
      },{
        name: 'DB_Gene',
        router: 'DB_Gene_Fold',
        description: 'gene'
      },{
        name: 'DB_GO',
        router: 'DB_GO_Fold',
        description: 'gene ontology'
      },{
        name: 'DB_Metabolite',
        router: 'DB_Metabolite_Fold',
        description: 'metabolites'
      },{
        name: 'DB_Pathway',
        router: 'DB_Pathway',
        description: 'pathway'
      },{
        name: 'DB_Protein',
        router: 'DB_Protein_Fold',
        description: 'proteins'
      },{
        name: 'DB_Meta',
        router: 'DB_Meta',
        description: 'references for meta-analysis'
      },{
        name: 'DB_Exposure_Gene',
        router: 'DB_Exposure_Gene',
        description: 'relationship between exposure and gene expression'
      },{
        name: 'DB_Exposure_GO',
        router: 'DB_Exposure_GO',
        description: 'relationship between exposure and GO (i.e. phenotype)'
      },{
        name: 'DB_Exposure_Pathway',
        router: 'DB_Exposure_Pathway',
        description: 'relationship between exposure and pathway'
      },{
        name: 'DB_Exposure_Protein',
        router: 'DB_Exposure_Protein',
        description: 'relationship between exposure and protein'
      },{
        name: 'DB_Gene_Disease',
        router: 'DB_Gene_Disease',
        description: 'relationship between gene and disease'
      },{
        name: 'DB_Gene_Protein',
        router: 'DB_Gene_Protein_Unfold',
        description: 'relationship between gene and protein'
      },{
        name: 'DB_GO_Disease',
        router: 'DB_GO_Disease',
        description: 'relationship between exposure and disease'
      },{
        name: 'DB_Pathway_Disease',
        router: 'DB_Pathway_Disease',
        description: 'relationship between pathway and disease'
      },{
        name: 'DB_Protein_Disease',
        router: 'DB_Protein_Disease',
        description: 'relationship between protein and disease'
      },{
        name: 'DB_Protein_Protein',
        router: 'DB_Protein_Protein',
        description: 'interactions between protein and protein'
      },{
        name: 'DB_NTA_Chemical',
        router: 'DB_NTA_Chemical',
        description: 'non-targeted analysis for chemical annotation'
      },{
        name: 'DB_NTA_IonAdduct',
        router: 'DB_NTA_IonAdduct',
        description: 'non-targeted analysis for the mass-to-charge conversion of ion adduct'
      }]
    };
  },
  methods: {
    async download_gz(item){
      let a = document.createElement('a')
      a.href = getDownloadUrl('demoV101', `${item.router}.tsv.gz`)
      a.target = '_blank'
      a.click()
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  font-size: $webpage-base-font-size;
  margin-left: 2em;
}
.title {
  font-weight: 600;
  font-size: $webpage-large-font-size;
  margin: 1em 0 0.6em;
}
.item-context {
  display: flex;
  gap: 60px;
  align-items: center;
  line-height: 1.6;
  margin: 0.2em 0;
  justify-content: start;
}
.line {
  width: 90%;
}
.item-word {
  min-width: 800px;
}
.item-word-1 {
  min-width: 770px;
  margin-left: 30px;
}
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .line {
    width: 100%;
  }
  .item-word {
    min-width: 0;
  }
  .item-word-1 {
    min-width: 0;
  }
  .item-context {
    justify-content: space-between;
  }
}
@media screen and (max-width: 600px) {
  .page {
    margin: 0;
  }
  .line {
    width: 100%;
  }
  .item-context {
    display: flex;
    gap: 1em;
    align-items: center;
    justify-content: space-between;
  }
  .item-word {
    min-width: 0;
  }
  .item-word-1 {
    min-width: 0;
    margin-left: 10px;
  }
}
</style>
